import { CountUp } from 'countup.js';

let countUpItems = $('.count-up-value');

if(countUpItems.length) {

    countUpItems.each(function (i, e) {

        let countUpItem = $(this),
            countUpValue = countUpItem.data('value');

        if(typeof countUpValue === 'string') {
            countUpValue = countUpValue.replace(/,/g, '');
            countUpValue = parseFloat(countUpValue);
        }

        let animation = new CountUp(countUpItem.attr('id'), countUpValue, {
            duration: 2,
            separator: ',',
            decimal: '.',
            prefix: '',
            suffix: '',
            // enableScrollSpy: true,
            // scrollSpyDelay: i * 200,
            // scrollSpyOnce: true
        });

        if (!animation.error) {
            if(countUpItem.closest('.animate').length) {
                console.log('here');
                let checkInterval = setInterval(function () {
                    if(countUpItem.closest('.animate').hasClass('animated')) {
                        animation.start();
                        clearInterval(checkInterval);
                    }
                }, 1000);

            } else {
                animation.start();
            }
        } else {
            console.error(animation.error);
        }

    });

}
